import React from 'react';
import styled from 'styled-components';
import { withLocalePrefix } from 'shared/utils/translation';
import GreenhouseLogo from './greenhouse_logo';
import {
  FieldNotice,
  SecondaryBodyText,
} from '@grnhse/seedling/lib/azalea/typography';
import { Link } from '@grnhse/seedling/lib/birch/typography';

const t = withLocalePrefix('self_schedule.candidate_view');

export type Props = {
  marketingLink: string;
  privacyPolicyLink: string;
};

const Footer = (props: Props) => {
  return (
    <Container>
      <Flex>
        <SecondaryBodyText>{t('powered_by')}</SecondaryBodyText>
        <FlexLink href={props.marketingLink}>
          <GreenhouseLogo />
        </FlexLink>
      </Flex>
      <Flex>
        <FieldNotice className="privacy-policy">{t('read_our')}</FieldNotice>
        <FieldNoticeLink href={props.privacyPolicyLink}>
          {t('privacy_policy')}
        </FieldNoticeLink>
      </Flex>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 50px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const FlexLink = styled(Link)`
  display: flex;
`;

const FieldNoticeLink = styled(Link)`
  font-size: 12px;
  line-height: 16px;
`;

export default Footer;
